import { useEffect, useState } from "react";

export function classNames(...classes: string[]): string {
    return classes.filter(Boolean).join(' ')
}

export function addAlpha(color: string, opacity: number): string {
    const _opacity = Math.round(
        Math.min(Math.max(opacity || 1, 0), 1) * 255
    )
    return color + _opacity.toString(16).toUpperCase()
}

function getWindowDimensions() {
    return {
        inner_width : window.innerWidth,
        inner_height : window.innerHeight
    };
  }
  
export function useWindowDimensions() {
    const [window_dimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return window_dimensions;
}

